import PublicSiteApi from '@app/api/public/PublicSiteApi';
import { useQuery } from 'react-query';

const useGetThemes = () => {
    return useQuery('getThemes', PublicSiteApi.listThemes);
};

export default useGetThemes;
